import { render, staticRenderFns } from "./kv-button.vue?vue&type=template&id=153a492e"
import script from "./kv-button.vue?vue&type=script&lang=js"
export * from "./kv-button.vue?vue&type=script&lang=js"
import style0 from "./kv-button.vue?vue&type=style&index=0&id=153a492e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports